import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import sift from "sift";
import { queryBuilder } from "../utils";
export var initPackages = function initPackages(a, b) {
  b.parseUrl;
  return {
    list: function list(b) {
      var c = b || {},
          d = c.sort,
          e = _objectWithoutProperties(c, ["sort"]); // Make the default sort the featured flag in desc order


      d || (d = "flags.featured-desc");
      var f = a.current,
          g = a.filters,
          h = f.packages || []; // For some reason the apiName have changed on inSite
      // so this should always set them to lot_area & lot_frontage
      // filters.landSize.apiName = "lot_area";
      // filters.frontage.apiName = "lot_frontage";

      return h.length ? queryBuilder(h, _objectSpread({}, e, {
        filters: g,
        sort: d
      })) : h;
    },
    retrieve: function retrieve(b, c) {
      var d = (c || {}).extend,
          e = "object" == typeof b ? b : {
        slug: b
      },
          f = null,
          g = a.current,
          h = g.packages || [];

      if (g && h && h.length && (f = h.find(sift(e)), f)) {
        var i = "apartment" === f.propertyType;

        if (i && !f.floorplate) {
          var j = a.neighbourhoods.retrieve(f.neighbourhood_slug);
          d && j.apartments.find(function (a) {
            var b = a.levels.find(function (a, b) {
              var c = a.apartments.find(function (a) {
                return a.package_id === f.id;
              });
              return c && (f.floor_number = b), c;
            });
            return b && (f.building = a.slug), b;
          });
        }

        f.similar && f.similar.length && (f.similar = f.similar.map(function (a) {
          return a && h.find(function (b) {
            return b && b.slug === a.slug;
          });
        }), f.similar = f.similar.filter(function (a) {
          return a;
        }));
      }

      return f;
    }
  };
};
export default initPackages;